import { Component, inject, OnInit } from '@angular/core';
import { AuthService, OrderConfirmationComponent } from 'gung-standard';

@Component({
    selector: 'otto-olsen-order-confirmation',
    templateUrl: './otto-olsen-order-confirmation.component.html',
    styleUrls: ['./otto-olsen-order-confirmation.component.scss'],
    standalone: false
})
export class OttoOlsenOrderConfirmationComponent extends OrderConfirmationComponent implements OnInit {

  protected authService = inject(AuthService)
  showScannerMenu = false;


  ngOnInit(): void {
    super.ngOnInit();
    this.authService
    .getHasRoles('SCANNER')
    .pipe()
    .subscribe(isScannerOnly => {
      this.showScannerMenu = isScannerOnly;
      
    });
  }

}
